import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SyncIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M22 2a1 1 0 1 0-2 0v3.8l-1.3-1.2A10 10 0 0 0 2 12a1 1 0 1 0 2 0 8 8 0 0 1 13.3-6l1 1H15a1 1 0 1 0 0 2h6c.6 0 1-.4 1-1V2ZM2 16c0-.6.4-1 1-1h6a1 1 0 1 1 0 2H5.6l1 1A8 8 0 0 0 20 12a1 1 0 0 1 2 0 10 10 0 0 1-16.7 7.4L4 18.2V22a1 1 0 1 1-2 0v-6Z" />
  </Icon>
));
export default SyncIcon;
